import { ReactElement } from 'react';
import { Form } from 'antd';

import { FormItem } from './components/form-item';
import { TCustomFormProps } from './types.ts';

export function CustomForm<T = object>(props: TCustomFormProps<T>): ReactElement {
    return <Form<T> layout="vertical" requiredMark={false} scrollToFirstError {...props} />;
}

CustomForm.Item = FormItem;
CustomForm.List = Form.List;
